// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Meta from 'vue-meta'
import store from './store'

import './assets/scss/custom.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import bFormSlider from 'vue-bootstrap-slider'
import 'bootstrap-slider/dist/css/bootstrap-slider.css'

import 'vue-awesome/icons'
import 'vue-awesome/icons/asterisk'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/close'
import 'vue-awesome/icons/file'
import 'vue-awesome/icons/clipboard'
import 'vue-awesome/icons/cloud-upload'
import 'vue-awesome/icons/list'
import Icon from 'vue-awesome/components/Icon'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import VeeValidate from 'vee-validate'

import VueClipboard from 'vue-clipboard2'

import axios from 'axios'
import VueAxios from 'vue-axios'

import VueAuth from './auth'

import auth from './auth/drivers/auth/bearer.js'
import http from './auth/drivers/http/axios.1.x.js'
import routerDriver from './auth/drivers/router/vue-router.2.x.js'

import 'babel-polyfill'

import App from './App'
import '@/assets/main.css'

const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

Vue.use(Meta)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(bFormSlider)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
Vue.use(VueClipboard)
Vue.use(VueAxios, axios)
Vue.router = router
Vue.config.productionTip = false
axios.defaults.baseURL = '/portalapi'
export const eventBus = new Vue()
Vue.use(VueAuth, {
  auth: auth,
  http: http,
  router: routerDriver,
  rolesVar: 'role',
  registerData: {url: '/user/register', method: 'POST', redirect: '/login'},
  loginData: {url: '/user/login', method: 'POST', redirect: '/', fetchUser: true},
  loginbackData: {url: 'user/loginback', method: 'POST', redirect: '/', fetchUser: true},
  logoutData: {url: '/user/logout', method: 'POST', redirect: '/', makeRequest: false},
  fetchData: {url: '/user/user', method: 'GET', enabled: true},
  refreshData: {url: '/user/refresh', method: 'GET', enabled: true, interval: 300}
})

Vue.component('icon', Icon)

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  store,
  router,
  components: { App }
}).$mount('#app')
